import { apiService as Service } from '@/services/service'

const url = 'help'

export interface HelpSessionResponse {
	/** Portal URL with the signed one-time handoff token appended as `?hs=`. */
	url: string
}

export const helpService = {
	/**
	 * Mints a handoff token for the help portal (API side: AAR-1539).
	 *
	 * The token lives 5 minutes and the gate burns it on first use, so every
	 * visit needs a fresh call — the URL must never be cached or reused.
	 * `silentError` keeps the global error dialog out of the way; the caller
	 * shows its own toast instead.
	 */
	session: () =>
		Service.post<HelpSessionResponse>({
			url: `${url}/session`,
			meta: { silentError: true },
		}),
}

export default helpService
